import { useEffect } from 'react';
import { useToast } from './ToastContext';

const useError403 = () => {

    const { addToast } = useToast();

  useEffect(() => {
    const handleError = (event) => {
      if (event.detail.status === 403) {
        addToast(event.detail.message || 'لا تملك صلاحية للوصول.', 'error', 3000);
      }
    };

    window.addEventListener('AxiosError403', handleError);

    return () => {
      window.removeEventListener('AxiosError403', handleError);
    };
  }, []);
};

export default useError403;